import { get } from 'lodash';
import {
  isEditableFormulaField,
  isEditedFormulaField,
} from '../../features/annotation-view/document-sidebar/formula-helpers';
import { getFromUnion } from '../../lib/helpers';
import {
  AnyDatapointData,
  AnyDatapointDataST,
  SimpleDatapointDataST,
  ValidationSources,
} from '../../types/datapoints';
import { AnyDatapointSchema } from '../../types/schema';

export const validationTickColor = (
  data: AnyDatapointDataST,
  active: boolean,
  suggestedOperation?: boolean,
  hasError?: boolean
): 'white' | 'green' | null => {
  const validationSources = getFromUnion(data, 'validationSources');

  if (
    get(data, ['schema', 'type']) === 'button' ||
    hasError ||
    suggestedOperation
  )
    return null;

  if (data?.meta?.sidebarDatapoint) {
    if (data.meta.isHumanValidated) return active ? 'white' : 'green';

    if (data.meta.isValidated) return 'white';
  }

  if ((validationSources ?? []).includes('human'))
    return active ? 'white' : 'green';

  if (validationSources?.length) return 'white';

  return null;
};

export const irrelevantTickInfo = (
  validationSources: Array<ValidationSources>,
  documentAutomated: boolean | undefined
) =>
  validationSources?.length === 1 &&
  validationSources.includes('not_found') &&
  !documentAutomated;

export const isLoggableDatapoint = (
  dp: AnyDatapointDataST | AnyDatapointData | undefined
): dp is SimpleDatapointDataST => {
  return dp !== undefined && dp.category === 'datapoint' && !!dp.content;
};

export const getLoggableDatapointValue = (
  dp: AnyDatapointDataST | AnyDatapointData | undefined
) => (isLoggableDatapoint(dp) ? dp.content?.value : undefined);

/** @deprecated prefer isEditableFormulaField */
export const isFieldEditableFormula = (
  fieldSchema: AnyDatapointSchema | undefined
) =>
  fieldSchema &&
  'uiConfiguration' in fieldSchema &&
  isEditableFormulaField(
    fieldSchema.uiConfiguration?.type ?? 'unset',
    fieldSchema.uiConfiguration?.edit ?? 'enabled'
  );

/** @deprecated prefer isEditedFormulaField */
export const isDatapointEditedFormulaField = (
  dp: AnyDatapointDataST | AnyDatapointData | undefined,
  fieldSchema: AnyDatapointSchema | undefined
) =>
  dp &&
  'noRecalculation' in dp &&
  fieldSchema &&
  'uiConfiguration' in fieldSchema &&
  isEditedFormulaField(
    fieldSchema.uiConfiguration?.type ?? 'unset',
    dp.noRecalculation
  );
